import React from 'react';
import { TextInput } from '../../../../UI';
import styles from './AdminChatForm.module.scss';

interface RelevanceInputProps {
  relevancePercent: number | undefined;
  onChange: (value: number | undefined) => void;
}

const RelevanceInput: React.FC<RelevanceInputProps> = ({ relevancePercent, onChange }) => {
  const handleChange = (value: string) => {
    if (value === '') {
      onChange(undefined);
    } else {
      const numValue = Number(value);
      if (!isNaN(numValue) && numValue >= 0 && numValue <= 100) {
        onChange(numValue);
      }
    }
  };

  return (
    <div className={styles.inputGroup}>
      <TextInput
        type="number"
        label="Min Relevance %"
        value={relevancePercent?.toString() ?? ''}
        onChange={handleChange}
        min={0}
        max={100}
        placeholder="Auto"
      />
    </div>
  );
};

export default RelevanceInput;
